/**
 * Business logic per Groups autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import groupsService from '../services/groupsService';
import type { GroupAutocompleteResult } from '../models/group';
import type { ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export interface GroupsAutocompleteOptions {
	searchString?: string;
	id?: number | string | null;
	notInIds?: Array<number | string> | null;
	orderId?: number | string | null;
}

export async function getGroupsAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: GroupsAutocompleteOptions = {},
): Promise<GroupAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null, orderId = null } = options;

	const context: ODataContext = {
		select: 'id,name',
		count: true,
		top: 20,
		orderBy: ['name'], // JS ha 'name' (stringa), ma TS vuole array
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [{ 'tolower(name)': { contains: searchString } }],
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [{ id: { in: notInIds } }],
		});
	}

	// Filtro per orderId: solo gruppi che hanno orders con questo jobOrderId
	if (orderId) {
		context.filter!.and!.push({
			orders: {
				any: {
					jobOrderId: orderId,
				},
			},
		});
	}

	const result = await groupsService.getGroups(buildQuery(context));
	// OData select: id, name - type safety garantita da Pick<>
	return result.value;
}
